import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useParams, useNavigate } from "react-router-dom";

function RedirectToCustomLink() {
  let { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const userLinks = {
      jose: "https://calendar.app.google/vHNC2dNF7cyaWkYb8",
    };

    if (userLinks[username]) {
      window.location.replace(userLinks[username]);
    } else {
      window.location.replace("https://rededelta.com.br/");
    }
  }, [username, navigate]);

  return ;
}
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:username" element={<RedirectToCustomLink />} />
        <Route path="/" element={<RedirectToCustomLink />} />
      </Routes>
    </Router>
  );
}

export default App;
